module.exports = __webpack_public_path__ + "static/img/pl.8dae9656.svg";